import React, { Component } from 'react';
import ConditionValue from './ConditionValue';

class LoopTarget extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}
  render() {
    const { data } = this.props;
    const props = {
      updateRule: this.props.updateRule,
      file: this.props.file,
      rule: this.props.rule,
      disabled: this.props.disabled
    };
    return (
      <div className="con-container">
        <div className="con-text">
          <strong>循环对象</strong>
        </div>

        <div className="condition-area">
          <ConditionValue item={data} {...props} />
        </div>
      </div>
    );
  }
}

export default LoopTarget;
